import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import paths from './paths';
import DEFINES from '@/defines'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  routes: paths,
});

router.beforeEach((to, from, next) => {
  //which layout to use ?
  var oldLayout = store.getters['app/appLayout'];
  var newLayout = to.meta.layout || DEFINES.LAYOUT_AUTH;

  /** ============== AVAIL LINK ROUTES =============  */

  /** If user is trying to access avails manager via avail link
   *  Do two things :-
   *  1. Send login request to allow user in system as member.
   *  2. Show films just after login with filters (if any).
   */

  if (to.name == 'AccessingAvailLink') {
    store.dispatch('availLink/login', {
      selected_company_id: to.params.company_id,
      uuid: to.params.uuid
    }, DEFINES.USE_ROOT);
  }

  /** ============== END =====================  */

  if (newLayout != oldLayout) {
    store.dispatch(
      'app/setAppLayout', {
        layout: newLayout
      },
      DEFINES.USE_ROOT
    );
  }

  if (store.getters['app/isLoggedIn'] && to.path.startsWith('/login')) {
    return next({
      name: 'Dashboard',
      params: {
        company_id: store.getters['company/getSelected'],
      },
    });
  }


  // if not Logged in move to LogIn Page
  if (
    to.matched.some(record => record.meta.public) != true &&
    !store.getters['app/isLoggedIn']
  ) {
    return next({
      path: '/login',
      query: {
        redirect: to.fullPath, // FIXME: redirect user after login
      },
    });
  }

  if (
    to.path.startsWith('/company') &&
    to.params.company_id != null &&
    to.params.company_id != store.getters['company/getSelected']
  ) {
    console.log('Switching Company from ')
    console.log('Old Company ID = ' + store.getters['company/getSelected']);
    console.log('New Comapny ID = ' + to.params.company_id)
    store.dispatch('company/switchSelectedCompanyId', {
      selected_company_id: to.params.company_id
    })
  }



  next();
});

export default router;
